import { useEffect, useState } from "react";

import Tag from "../Tag"

const CountdownTag = ({ timestamp = null, ...rest }) => {
    const [fakeCurrentDate, setFakeCurrentDate] = useState(new Date());

    useEffect(() => {
        setTimeout(() => setFakeCurrentDate(new Date()), 1000);
    }, [fakeCurrentDate]);

    if (timestamp === null) {
        return null;
    }

    const currentTime = Math.floor(new Date().getTime() / 1000);
    let seconds = timestamp - currentTime;
    if (seconds < 0) {
        seconds = 0;
    }

    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    return <Tag {...rest} tag={`${`${hours}`.padStart(2, '0')}:${`${mins}`.padStart(2, '0')}:${`${secs}`.padStart(2, '0')}`} />
}

export default CountdownTag;
